/* eslint-disable camelcase */
import React, { Component } from 'react';
import NbugsEcharts from 'nbugs-echarts';
import styles from './echarts.less';

class BarEcharts extends Component {
  render() {
    const { title = '', data = [] } = this.props;
    const typeProps = {
      width: '100%',
      height: '100%',
    };
    const axisProps = {
      type: 'x',
      name: { y: '学校数量' },
    };

    return (
      <div className={styles.echarts}>
        <div className='wrap'>
          <div className='title'>{title}</div>
          <div className='details-wrap'>
            <div id="barContainer" style={{ width: '100%', height: '100%' }} />
            <NbugsEcharts
              type="bar"
              echartsId="barContainer"
              typeProps={typeProps}
              dataSource={data}
              axisProps={axisProps}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default BarEcharts
